import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import CrossBorderWithdrawalInfo from './CrossBorderWithdrawalInfo';
import useFetchCrossBorderTransactions from '@/hooks/useApi/useFetchCrossBorderTransactions';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type CrossBorderWithdrawalContainerProps = {
  transactionId: string;
} & Omit<ComponentProps<typeof CrossBorderWithdrawalInfo>, 'transaction'>;

export default function CrossBorderWithdrawalContainer({
  transactionId,
  jwt,
  transactionDetail,
  ...props
}: CrossBorderWithdrawalContainerProps) {
  const { accountId } = transactionDetail;
  const { userSettings } = useUserSettingsProvider();
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { transactions, fetchTransactions } = useFetchCrossBorderTransactions({ bearer: jwt });

  useEffect(() => {
    blockingLoader.show();

    fetchTransactions({
      ClientAccountID: accountId,
      TransactionID: transactionId,
      Timezone: userSettings.timezone,
    })
      .catch((error) =>
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred')),
      )
      .finally(() => blockingLoader.hide());
  }, [transactionId, accountId]);

  const transaction = transactions.find((t) => t.TransactionID === transactionId);

  return (
    <div>
      {transaction && (
        <CrossBorderWithdrawalInfo
          transaction={transaction}
          jwt={jwt}
          transactionDetail={transactionDetail}
          {...props}
        />
      )}
    </div>
  );
}
